import { extractNavPathFromString, NavPath } from 'src/pages/NavigationShell/navigationUtils';
import { isEqual } from 'lodash';
import store from 'src/store';
import { isSome } from 'fp-ts/es6/Option';

export const getViewNameFromPath = (path: NavPath): string | undefined => {
  const viewLinks = store.getState().perspective.viewLinks;
  return viewLinks.find((v) => {
    const viewLinkNavPath = extractNavPathFromString(v.link);
    if (isSome(viewLinkNavPath)) {
      // we only care about the top level screen name, not the full path including tabs
      // (since we don't have those saved in nav, as they are part of worklist view defn)
      const foundPath = viewLinkNavPath.value?.slice(0, 4);
      const checkPath = path.slice(0, 4);
      return isEqual(foundPath, checkPath);
    } else {
      return false;
    }
    // return isSome(viewLinkNavPath) && isEqual(path, viewLinkNavPath.value);
  })?.name;
};
